<template>
    <div class="search-result-bottom-button-box">
        <div class="search-result-bottom-select" v-if="showSearchItemSelect">
            <span class="span-select" @click="selectAll"><span>全选</span></span>
            <span class="span-select" @click="invertAll"><span>反选</span></span>
        </div>
        <div class="search-result-bottom-button" @click="clickContrast">多选对比</div>
    </div>
</template>

<script>
export default {
    name: 'SearchSelectButton',
    props: {
        fromPage: {
            type: String,
            default() { return '' }
        },
        selectFunc: {
            type: Function,
            default() { return undefined }
        }
    },
    computed: {
        showSearchItemSelect() {
            return this.$store.state.search.showSearchItemSelect;
        }
    },
    methods: {
        clickContrast() {
            if(!this.showSearchItemSelect) {
                this.$store.state.search.showSearchItemSelect = true;
                if(this.selectFunc && typeof(this.selectFunc) == 'function') {
                    this.selectFunc();
                }
            }else {
                let selectedList = this.$store.state.search.searchResultSelectedList;
                console.log('clickContrast---', selectedList);

                // 选择条数限制
                if(selectedList.length < 2) {
                    this.$toast('请至少选择两条八字数据');
                    return;
                }
                // 会员限制
                let userVip = this.$store.state.userData.vip;
                if(userVip == 0 || (userVip == 10 && selectedList.length > 8)) {
                    if(userVip == 10) {
                        this.$toast('月会员最多只能对比8个八字');
                    }
                    this.$store.dispatch('user/showMyVipPop', {vip: userVip, frompage: 'compare_search'});
                    setTimeout(() => {
                        this.$bus.emit('initMyVipPage');
                    }, 20);
                    return;
                }
                // 一键对比:展示弹框
                this.$store.state.contrast.showContrastCreatePanel = true;
            }
        },
        selectAll() {
            let idArr = [];
            let tempArr = this.fromPage == 'searchResult' ? this.$store.state.search.searchResultList : this.fromPage == 'advancedSearchResult' ? this.$store.state.search.searchAdvancedResultList : [];
            tempArr.forEach(element => {
                element.selected = true;
                idArr.push(element.id);
            });
            this.$store.dispatch('search/addSearchResultSelectedList', {
                type: 'all', idArr: idArr
            });
        },
        invertAll() {
            let addArr = [], removeArr = [];
            let tempArr = this.fromPage == 'searchResult' ? this.$store.state.search.searchResultList : this.fromPage == 'advancedSearchResult' ? this.$store.state.search.searchAdvancedResultList : [];
            tempArr.forEach(element => {
                element.selected = !element.selected;
                if(element.selected) {
                    addArr.push(element.id);
                }else {
                    removeArr.push(element.id);
                }
            })
            if(addArr.length > 0) {
                this.$store.dispatch('search/addSearchResultSelectedList', {
                    type: 'add', idArr: addArr
                });
            }
            if(removeArr.length > 0) {
                this.$store.dispatch('search/removeSearchResultSelectedList', {
                    type: 'remove', idArr: removeArr
                });
            }
        }
    }
}
</script>